"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trash = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Trash = function Trash(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5 9.75C10.0853 9.75 9.75 10.0853 9.75 10.5V16.5C9.75 16.9148 10.0853 17.25 10.5 17.25C10.9147 17.25 11.25 16.9148 11.25 16.5V10.5C11.25 10.0853 10.9147 9.75 10.5 9.75Z",
    fill: "#D81A26"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.5 9.75C13.0853 9.75 12.75 10.0853 12.75 10.5V16.5C12.75 16.9148 13.0853 17.25 13.5 17.25C13.9147 17.25 14.25 16.9148 14.25 16.5V10.5C14.25 10.0853 13.9147 9.75 13.5 9.75Z",
    fill: "#D81A26"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.25 2.25H9.75C8.92275 2.25 8.25 2.92275 8.25 3.75V5.25H6H3.75C3.33525 5.25 3 5.58525 3 6C3 6.41475 3.33525 6.75 3.75 6.75H5.25V19.5C5.25 20.7405 6.2595 21.75 7.5 21.75H16.5C17.7405 21.75 18.75 20.7405 18.75 19.5V6.75H20.25C20.6647 6.75 21 6.41475 21 6C21 5.58525 20.6647 5.25 20.25 5.25H18H15.75V3.75C15.75 2.92275 15.0773 2.25 14.25 2.25ZM17.25 19.5C17.25 19.914 16.914 20.25 16.5 20.25H7.5C7.086 20.25 6.75 19.914 6.75 19.5V6.75H17.25V19.5ZM9.75 5.25V3.75H14.25V5.25H9.75Z",
    fill: "#D81A26"
  }));
};
exports.Trash = Trash;